import StyleContext from 'isomorphic-style-loader/StyleContext';
import type { PropsWithChildren } from 'react';
import { useMemo } from 'react';

import { getInsertCSS } from './style-registry';

/**
 * Provides a context to collect CSS imports on the server and client.
 *
 * On the server, critical-path styles are added to a request-scoped registry
 * resolved via `AsyncLocalStorage`. On the client, styles are injected into
 * the document as they are loaded.
 */
export const StyleProvider = ({ children }: PropsWithChildren) => {
  const insertCss = getInsertCSS();
  const value = useMemo(() => ({ insertCss }), [insertCss]);

  return (
    <StyleContext.Provider value={value}>{children}</StyleContext.Provider>
  );
};

export default StyleProvider;
